'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinksMapper = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LinksMapper, _Component);

  function LinksMapper(props) {
    (0, _classCallCheck3.default)(this, LinksMapper);
    return (0, _possibleConstructorReturn3.default)(this, (LinksMapper.__proto__ || (0, _getPrototypeOf2.default)(LinksMapper)).call(this, props));
  }

  (0, _createClass3.default)(LinksMapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var linkButtons = [];
      var moreInfoLinks = false;
      if (this.props.moreInfo) {
        moreInfoLinks = true;
      }
      if (this.props.links && this.props.links.length > 0) {
        linkButtons = this.props.links.map(function (elem, index) {
          return _react2.default.createElement(_components.RichLink, {
            key: "link" + index,
            chapter: index,
            element: elem,
            action: _this2.props.action,
            hoverAction: _this2.props.hoverAction,
            inactiveClass: true,
            moreInfo: moreInfoLinks
          });
        });
      }

      var iconRight = this.props.rightIcon ? _react2.default.createElement('i', { className: 'icon-group-6' }) : '';

      return _react2.default.createElement(
        'div',
        { className: this.props.customClass || "links" },
        linkButtons,
        iconRight
      );
    }
  }]);
  return LinksMapper;
}(_react.Component), _class.propTypes = {
  name: _propTypes2.default.string
}, _class.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired
}, _temp);
exports.default = LinksMapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Links/LinksMapper.jsx
// module id = 714
// module chunks = 0